<template>
   <div class="h-100 d-flex flex-column justify-content-center">
      <!-- <p>{{$t('questionnaire.loading')}}</p> -->
      <LoadingAnimation :color="'Grey'"></LoadingAnimation>
   </div>
</template>

<script>
import globalValues from '@/core/helpers/enums/globalValues';
import RouterPush from '@/core/helpers/routerPush';
import SetSessionStorage from '@/core/helpers/setSessionStorage';
const setSessionStorage = new SetSessionStorage();
const routerPush = new RouterPush();

export default {
   components: {
      LoadingAnimation: () => import('@/core/components/LoadingAnimation'),
   },

   created() {
      this.getSubmission();
   },

   data() {
      return {
         submission: null,
      };
   },

   methods: {
      getSubmission() {
         sessionStorage.setItem(globalValues.candidate.journeyRandom, this.$route.params.submissionId);
         this.$store.dispatch('getSubmissionById', this.$route.params.submissionId).then((response) => {
            this.submission = response;
            this.setColorScheme();
            sessionStorage.setItem(globalValues.candidate.email, response.email);
            sessionStorage.setItem(globalValues.candidate.phone_number, response.phone_number);
            if (this.submission.person) {
               setSessionStorage.candidateId(this.submission.person.id);
            }
            setSessionStorage.firstName(this.submission.first_name);
            setSessionStorage.lastName(this.submission.last_name);
            let isNoCandidateSteps = this.submission.candidate_steps.length == 0;

            if (isNoCandidateSteps) {
               routerPush.toJourneyQuestion(this.submission.journey, this.submission.entry_referral.code, 1, 1, 1);
            } else {
               this.loadSubmission();
            }
         });
      },

      setColorScheme() {
         const tenant = this.submission.entry_referral.journey_team.team.tenant;
         sessionStorage.setItem('primary_color_code', tenant.primary_color_code);
         sessionStorage.setItem('header_color_code', tenant.header_color_code);
         sessionStorage.setItem('background_color_code', tenant.background_color_code);
         this.$store.commit('setShowTitleInHeader', tenant.show_title_in_header);
         this.$store.commit('setHeaderName', tenant.name);
         this.$store.dispatch('getFileById', tenant.file_id).then((response) => {
            this.$store.commit('setLogo', response);
            sessionStorage.setItem('logo', response);
         });
      },

      loadSubmission() {
         let stepLength = this.submission.candidate_steps.length - 1;

         let stepIndex = this.submission.journey.steps.findIndex((step) => step.id === this.submission.candidate_steps[stepLength].step_id);
         let candidateStep = this.submission.candidate_steps[stepLength];
         let isNewStep =
            candidateStep.successful == 1 && candidateStep.finished == 1 && stepLength + 1 != this.submission.journey.steps.length;
         let isJourneyEnded = this.submission.finished;

         setSessionStorage.journeyId(this.submission.id);
         if (this.submission.person) {
            setSessionStorage.candidateId(this.submission.person.id);
         }
         setSessionStorage.stepId(candidateStep.id);
         setSessionStorage.firstName(this.submission.first_name);
         setSessionStorage.lastName(this.submission.last_name);

         if (isJourneyEnded) {
            routerPush.toJourneyEnd(this.submission.journey, this.submission.entry_referral.code);
         } else if (isNewStep) {
            this.$store
               .dispatch('getCandidateNextStep', this.submission.random)
               .then((response) => {
                  let nextStepIndex = response.sequence / 10;
                  this.$store.commit('setIsSubmissionRedirect', true);
                  routerPush.toJourneyQuestion(this.submission.journey, this.submission.entry_referral.code, nextStepIndex, 1, 1);
               })
               .catch((error) => {
                  if (error.response.data.message === 'No next step.') {
                     this.$emit('endJourney');
                     routerPush.toJourneyEnd(this.submission.journey, this.submission.entry_referral.code);
                  }
               });
         } else {
            this.$store.commit('setIsSubmissionRedirect', true);
            setSessionStorage.journeyId(this.submission.id);
            setSessionStorage.stepId(this.submission.candidate_steps[stepLength].id);

            let isCurrentQuestionReached = false;
            let isCurrentQuestionPassed = false;
            let currentStep = stepIndex + 1;
            let currentPage = 1;
            let currentModule = 1;

            const step = this.submission.journey.steps[stepIndex];
            const candidateStep = this.submission.candidate_steps[this.submission.candidate_steps.length - 1];
            step.modules.forEach((module, moduleIndex) => {
               const answerWithoutFile = candidateStep.answers.find(
                  (answer) =>
                     (answer.module_id == module.id && module.module_type_id == 7 && module.is_obligated == 1 && answer.file_id == null) ||
                     (answer.module_id == module.id && module.module_type_id == 11 && module.is_obligated == 1 && answer.file_id == null)
               );
               if (answerWithoutFile && !isCurrentQuestionPassed) {
                  isCurrentQuestionPassed = true;
                  currentStep = stepIndex + 1;
                  currentPage = module.page_sequence / 10;
                  currentModule = moduleIndex + 1;
               } else if (!answerWithoutFile && !isCurrentQuestionPassed) {
                  const latestFoundAnswer = candidateStep.answers.find((answer) => answer.module_id == module.id);

                  if (!latestFoundAnswer) {
                     isCurrentQuestionReached = true;
                  }

                  if (isCurrentQuestionReached && !isCurrentQuestionPassed && !answerWithoutFile) {
                     isCurrentQuestionPassed = true;
                     currentStep = stepIndex + 1;
                     currentPage = module.page_sequence / 10;
                     currentModule = moduleIndex + 1;
                  }
               }
            });
            routerPush.toJourneyQuestion(
               this.submission.journey,
               this.submission.entry_referral.code,
               currentStep,
               currentPage,
               currentModule
            );
         }
      },
   },
};
</script>

<style>
html,
body,
#app {
   height: 100% !important;
}
</style>

